import { AbstractDataProviderV2, adapter, DataProvider } from 'components/system';
import { ActionTypes, ICollectionParams, IList, IResourceParams } from 'components/system/data-provider/models';
import { RsCustomerImage } from 'common/customers/services/types/RsCustomerImage';
import { RsCustomerImageInfo } from 'common/customers/services/types/RsCustomerImageInfo';
import { CustomerImageAdd } from 'common/customers/services/types/CustomerImageAdd';
import { CustomerImageUpdate } from 'common/customers/services/types/CustomerImageUpdate';

export class CustomerImageDataProvider extends AbstractDataProviderV2<RsCustomerImage, RsCustomerImageInfo, CustomerImageAdd, CustomerImageUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/images');
    }

    list(collectionParams = {}, resourceParams = {}, timeout?) {
        return this.getTList<RsCustomerImage>(collectionParams, resourceParams, timeout);
    }

    update(item, resourceParams) {
        //const url = `middle://rs/customers/${resourceParams.customerId}/images/${resourceParams.id}`;
        const url = this.getResourceUrl(resourceParams);
        return this.service.updateRequest<RsCustomerImageInfo>(url, 'PUT', item).then(result => {
            this.notify({ type: ActionTypes.Update, hash: url }, true);
            return result;
        });
    }
    //
    remove(resourceParams) {
        const url = this.getResourceUrl(resourceParams);
        return this.service.updateRequest<void>(url, 'DELETE').then(result => {
            this.notify({ type: ActionTypes.Remove, hash: url }, true);
            return result;
        });
    }

    getMainImage(resourceParams) {
        /*
         TMax 20170411 not implemented yet in api
         filters:{main:true}
         */
        return this.all({}, resourceParams).then(items => {
            return items.find(item => item.main);
        });
    }
    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
}
